import React from 'react'

import { Element } from './styles'

import LazyImage from 'components/shared/LazyImage'
import { Button } from 'components/v2/Button'
import { Row } from 'components/v2/Grid'
import { Text } from 'components/v2/Text'

const ScheduleAppointmentHome = ({ handleModal }) => (
	<section id='schedule-appointment'>
		<Row className='flex-wrap bg-[#4D4D00] py-16 text-white'>
			<Row className='mx-auto max-w-[1200px] flex-wrap justify-center px-3'>
				<Text as='h2' className='mb-[50px] text-center text-2xl leading-[38px] md:text-3xl'>
					Como começar minha terapia online
				</Text>
				<Row className='mb-12 min-w-full flex-wrap items-center pb-[50px]'>
					<Element className='items-center justify-center pb-4 md:flex-[0_0_33%] md:pb-0 lg:flex-[0_0_25%]'>
						<LazyImage
							loading='lazy'
							height={42}
							src='/static/images/home-vector1.svg'
							alt='ícone de pesquisa'
							className='lazy'
						/>
						<Text className='mt-6 text-center'>
							Encontre seu psicólogo com o Vittude Match
						</Text>
					</Element>
					<Element className='items-center justify-center pb-4 md:flex-[0_0_33%] md:pb-0 lg:flex-[0_0_25%]'>
						<LazyImage
							loading='lazy'
							height={42}
							src='/static/images/home-vector3.svg'
							alt='calendário'
							className='lazy'
						/>
						<Text className='mt-6 text-center'>
							Escolha o dia e horário mais convenientes para você
						</Text>
					</Element>
					<Element className='items-center justify-center pb-4 md:flex-[0_0_33%] md:pb-0 lg:flex-[0_0_25%]'>
						<LazyImage
							loading='lazy'
							height={42}
							src='/static/images/home-vector2.svg'
							alt='calendário'
							className='lazy'
						/>
						<Text className='mt-6 text-center'>
							Defina o método de pagamento mais confortável para você
						</Text>
					</Element>
					<Element className='items-center justify-center pb-4 md:flex-[0_0_33%] md:pb-0 lg:flex-[0_0_25%]'>
						<LazyImage
							loading='lazy'
							height={42}
							src='/static/images/home-vector4.svg'
							alt='calendário'
							className='lazy'
						/>
						<Text className='mt-6 text-center'>
							Em um lugar tranquilo, faça sua sessão do computador ou celular.
						</Text>
					</Element>
				</Row>
				<Row className='min-w-full flex-wrap justify-center'>
					<Button
						onClick={handleModal}
						variant='light'
						id='choose-psychologist'
						className='h-12 w-full font-semibold md:w-auto'
					>
						Escolher meu psicólogo
					</Button>
				</Row>
			</Row>
		</Row>
	</section>
)

export default ScheduleAppointmentHome
